<template>
  <div class="card-start-container">

    <h1 class="header">Не может быть!</h1>

    <div class="card card-start">

      <p class="p p_0">В&nbsp;интернете есть всё.<br/>Вообще всё. Но&nbsp;в&nbsp;некоторые вещи всё равно не&nbsp;верится!</p>

      <p class="p p_1">В&nbsp;этом тесте мы&nbsp;собрали коллекцию видео, которые произвели на&nbsp;нас самые сильные впечатления. И&nbsp;(возможно) разбавили их&nbsp;выдуманными примерами.</p>

      <p class="p p_2">Проверь себя и&nbsp;угадай, что здесь реально, а&nbsp;что&nbsp;&mdash; нет!</p>

    </div>

    <ButtonClassic
      @click="$emit('start')"
      class="button-classic_start"
      text="Ну, посмотрим!"
    />

  </div>
</template>

<script>
import ButtonClassic from './ButtonClassic.vue'

export default {

  name: 'CardStart',

  components: {

    ButtonClassic

  },

  methods: {
    openLinkTest(link) {
      window.open(link)
    },
    alertTest() {
      document.getElementById('app').style.backgroundColor = 'red'
    }
  }

}
</script>

<style lang="sass">

.card-start-container
  display: flex
  flex-direction: column
  justify-content: center
  align-items: center

  position: absolute

  top: calc(50% - 246px)

.card-start
  width: 355px
  background-color: white
  padding: 30px 18px
  height: 292px
  justify-content: space-between

.header
  font-family: "VK Sans Display"
  color: white
  text-transform: uppercase
  width: 200px
  font-weight: 400
  margin: 0 auto
  text-align: center
  margin-bottom: 16px
  font-size: 2.3em
  line-height: 100%

.p
  color: black
  max-width: 95%
  font-weight: 500
  text-align: center

  &_0
    color: #D357FF
    font-size: 1.3em

  &_1
    font-weight: 500

  &_2
    font-weight: 600

@media (max-width: 420px)

  .card-start
    width: 80vw
    height: 70vw
    padding: 6.64% 4.3%
    border-radius: 3.75vw

    &-container
      top: calc(50% - 57vw)

  .p_0
    font-size: 1.2em

  .p_2
    font-size: 1.05em
    line-height: 146%

  .header
    font-size: 2em
    max-width: 60%

</style>
